import * as DialogPrimitive from "@radix-ui/react-dialog";
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef, type HTMLAttributes } from "react";
import { cn } from "../lib/utils";

export const Modal = DialogPrimitive.Root;
export const ModalTrigger = DialogPrimitive.Trigger;
export const ModalClose = DialogPrimitive.Close;

export const ModalOverlay = forwardRef<
  ElementRef<typeof DialogPrimitive.Overlay>,
  ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay className={cn("sqk-modal__overlay", className)} ref={ref} {...props} />
));
ModalOverlay.displayName = "ModalOverlay";

export const ModalContent = forwardRef<
  ElementRef<typeof DialogPrimitive.Content>,
  ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & { placement?: "center" | "right" | "right-full" }
>(({ placement = "center", className, children, ...props }, ref) => (
  <DialogPrimitive.Portal>
    <ModalOverlay />
    <DialogPrimitive.Content
      className={cn("sqk-modal__content", className)}
      data-placement={placement}
      ref={ref}
      {...props}
    >
      {children}
      <DialogPrimitive.Close aria-label="Close dialog" className="sqk-modal__close">Close</DialogPrimitive.Close>
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
));
ModalContent.displayName = "ModalContent";

export function ModalHeader({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <header className={cn("sqk-modal__header", className)} {...props} />;
}

export const ModalTitle = forwardRef<
  ElementRef<typeof DialogPrimitive.Title>,
  ComponentPropsWithoutRef<typeof DialogPrimitive.Title>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Title className={cn("sqk-modal__title", className)} ref={ref} {...props} />
));
ModalTitle.displayName = "ModalTitle";

export const ModalDescription = forwardRef<
  ElementRef<typeof DialogPrimitive.Description>,
  ComponentPropsWithoutRef<typeof DialogPrimitive.Description>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Description className={cn("sqk-modal__description", className)} ref={ref} {...props} />
));
ModalDescription.displayName = "ModalDescription";
